export default class ApiError extends Error {
  constructor(public response: Response) {
    super(response.statusText);
  }
}
